export function Moderate(props: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className={props.className}
      fill="none"
    >
      <path
        d="M2.4375 2.4375V15.4375C2.4375 15.8685 2.6087 16.2818 2.91345 16.5865C3.2182 16.8913 3.63152 17.0625 4.0625 17.0625H17.0625"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5984 3.53346C15.3122 3.52352 16.097 3.53344 16.5652 3.61256L16.5642 3.61354C16.8096 3.65466 17.029 3.78622 17.1785 3.98366C17.3273 4.18021 17.3966 4.42685 17.3689 4.67506L17.3308 4.94069C17.2786 5.28009 17.1829 5.82066 17.0672 6.38698C16.9136 7.13833 16.7105 8.01041 16.5066 8.56374C16.3723 8.92763 15.9688 9.12005 15.6053 8.99342C15.242 8.86657 15.0562 8.46867 15.1902 8.10475C15.3528 7.66336 15.5381 6.88776 15.6922 6.13405C15.6988 6.10181 15.7034 6.06923 15.7098 6.03737L6.67753 12.8264C6.36854 13.0586 5.92934 12.9966 5.69706 12.6878C5.46494 12.3788 5.52703 11.9396 5.83573 11.7073L14.8553 4.92897C14.7689 4.92934 14.6806 4.92773 14.5916 4.92897C13.8812 4.93888 13.168 4.9726 12.7781 4.99831C12.3912 5.02343 12.0631 4.73141 12.0447 4.34694C12.0265 3.96237 12.3256 3.63027 12.7127 3.60475C13.1266 3.57747 13.8634 3.54371 14.5984 3.53346Z"
        fill="currentColor"
      />
    </svg>
  );
}
